import OrigemRotulo from "@/models/enum/rotulo/origemRotulo";
import { getPaginationParams } from "@/utils/common/http";

import ConfiguracaoIntegracaoModel from "../models/configuracaoIntegracaoModel";
import FranquiaModel from "../models/franquiaModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";
import { getCookie, mensagemErro } from "./utils/serviceUtils";

class FranquiaService extends iServiceCached<FranquiaModel> {
    constructor() {
        super("Franquia");
    }

    public getFranquiaBaseReplicar(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFranquiaBaseReplicar?franquiaId=${id}`, {
            credentials: "same-origin",
        });
    }

    //id eh a franquia selecionada e base eh de onde busca os dados para esta franquai
    public replicar(id: number, franquiaBaseId = 1) {
        return nfetch(`/${this.controllerName}/Replicar?franquiaId=${id}&franquiaBaseId=${franquiaBaseId}`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": getCookie("XSRF-TOKEN"),
            },
        });
    }

    public excluirDadosFranquia(franquiaId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/ExcluirDadosFranquia?franquiaId=${franquiaId}`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": getCookie("XSRF-TOKEN"),
            },
        });
    }

    public getIntegracoesFranquia(franquiaId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetIntegracoesFranquia?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }

    public updateIntegracao(model: ConfiguracaoIntegracaoModel): Promise<Response> {
        //@ts-ignore
        return nfetch(`/${this.controllerName}/UpdateIntegrador`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        })
            .then((response: Response) => {
                if (response.ok) {
                    return response;
                } else {
                    return mensagemErro(response, "Save");
                }
            })
            .catch(() => {});
    }

    public listFranquiasFiliais(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        showFiliais = false,
    ): Promise<Response> {
        const pagination = getPaginationParams(filterKey, sortKey, sortOrder, pageIndex, pageSize);

        return nfetch(`/${this.controllerName}/ListFranquiasFiliais?${pagination}&showFiliais=${showFiliais}`, {
            credentials: "same-origin",
        });
    }

    public insertWithLogo(model: FranquiaModel, logo?: File): Promise<Response> {
        const data = new FormData();
        data.append("franquiaJson", JSON.stringify(model));
        if (logo) {
            data.append("logo", logo);
        }

        return nfetch(`/${this.controllerName}/InsertWithLogo`, {
            method: "post",
            credentials: "same-origin",
            body: data,
        });
    }

    public updateWithLogo(model: FranquiaModel, logo?: File): Promise<Response> {
        const data = new FormData();
        data.append("franquiaJson", JSON.stringify(model));
        if (logo) {
            data.append("logo", logo);
        }

        return nfetch(`/${this.controllerName}/UpdateWithLogo`, {
            method: "post",
            credentials: "same-origin",
            body: data,
        });
    }

    public ListFranquiasMatrizFiliais(): Promise<Response> {
        return nfetch(`/${this.controllerName}/ListFranquiasMatrizFiliais`, {
            credentials: "same-origin",
        });
    }

    public async comboCached(franquiaId: number, somenteAtivos?: boolean, refresh?: boolean): Promise<FranquiaModel[]> {
        const franquias = await this.combo(franquiaId, refresh);
        return franquias.filter(f => (somenteAtivos ? f.ativo : true));
    }

    public getFranquiaIdByOrigemDadosRotulo(dadosId: number, origemDados: OrigemRotulo): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetFranquiaIdByOrigemDadosRotulo?dadosId=${dadosId}&origemDados=${origemDados}`,
            {
                credentials: "same-origin",
            },
        );
    }
}

export default new FranquiaService();
